/** Operator identity (Q8). Single source for About/Contact/legal/footer/schema. */
export const COMPANY_LEGAL_NAME = 'Phi Digital LLC';
export const COMPANY_LEGAL_FORM = 'a Wyoming limited liability company';
export const COMPANY_OPERATOR_LINE = `${COMPANY_LEGAL_NAME}, ${COMPANY_LEGAL_FORM}`;
export const BRAND_NAME = 'CFA Mock Exam';
